import axios from 'axios';

export const fetchRoutes = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/routes`); // Replace with your API URL
        return response.data;
    } catch (error) {
        console.error('Error fetching routes:', error);
        return [];
    }
};
